import React from 'react';
import { Loader2 } from 'lucide-react';

interface ButtonProps {
  variant?: 'primary' | 'secondary' | 'danger' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  disabled?: boolean;
  loading?: boolean;
  loadingText?: string;
  className?: string;
  onClick?: () => void;
  type?: 'button' | 'submit' | 'reset';
  children: React.ReactNode;
}

const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  size = 'md',
  disabled = false,
  loading = false,
  loadingText = 'Loading...',
  className = '',
  onClick,
  type = 'button',
  children
}) => {
  const getVariantClass = () => {
    switch (variant) {
      case 'primary':
        return 'button-primary';
      case 'secondary':
        return 'button-secondary';
      case 'danger':
        return 'button-danger';
      case 'ghost':
        return 'button-ghost';
      default:
        return 'button-primary';
    }
  };

  const getSizeClass = () => {
    switch (size) {
      case 'sm':
        return 'button-sm';
      case 'md':
        return 'button-md';
      case 'lg':
        return 'button-lg';
      default:
        return 'button-md';
    }
  };

  const buttonClass = [
    'button',
    getVariantClass(),
    getSizeClass(),
    disabled && 'button-disabled',
    loading && 'button-loading',
    className
  ].filter(Boolean).join(' ');

  return (
    <button
      type={type}
      className={buttonClass}
      disabled={disabled || loading}
      onClick={onClick}
    >
      {loading ? (
        <span className="loading-spinner">
          <Loader2 className="animate-spin" size={size === 'sm' ? 14 : size === 'lg' ? 20 : 16} />
          <span style={{ marginLeft: '8px' }}>{loadingText}</span>
        </span>
      ) : (
        children
      )}
    </button>
  );
};

export default Button; 